module.exports = __webpack_public_path__ + "img/20200613_140245.86e16564.jpg";